import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center bg-white rounded-lg p-8 border-2 border-gray-300" }
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" }
const _hoisted_3 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_4 = { class: "mt-1 max-w-2xl text-sm text-gray-500" }
const _hoisted_5 = { class: "flex flex-col gap-4 sm:gap-0" }
const _hoisted_6 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:py-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "id",
  class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, null, -1)
const _hoisted_8 = { class: "grid grid-cols-2 mt-1 sm:mt-0 sm:col-span-2 flex gap-8 text-center" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = { class: "hidden sm:block text-sm font-medium text-gray-700 sm:py-5" }
const _hoisted_11 = { class: "grid gap-2" }
const _hoisted_12 = { class: "hidden sm:block text-sm font-medium text-gray-700 sm:py-5" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "flex flex-col gap-4 sm:gap-0" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "pt-5" }
const _hoisted_29 = { class: "flex justify-end" }
const _hoisted_30 = {
  type: "submit",
  class: "ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yesNoCurrHistRadio = _resolveComponent("yesNoCurrHistRadio")!
  const _component_currHistTextarea = _resolveComponent("currHistTextarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "space-y-8 divide-y divide-gray-200",
      onSubmit: _cache[93] || (_cache[93] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('Comorbidity.Title')), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Comorbidity.PersonalPatientInfo')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Comorbidity.Present')), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Comorbidity.History')), 1)
                ])
              ])
            ]),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.other_adhd_neurodes'),
              dataPresent: _ctx.comorbidities.current_other_adhd_neurodes,
              onYesNoPresentEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.comorbidities.current_other_adhd_neurodes = $event)),
              dataHistory: _ctx.comorbidities.history_other_adhd_neurodes,
              onYesNoHistoryEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.comorbidities.history_other_adhd_neurodes = $event)),
              key: _ctx.comorbidities.current_other_adhd_neurodes || _ctx.comorbidities.history_other_adhd_neurodes
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (_ctx.comorbidities.current_other_adhd_neurodes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.intel_def'),
                        dataPresent: _ctx.comorbidities.intel_def,
                        onYesNoPresentEvent: _cache[2] || (_cache[2] = ($event: any) => (_ctx.comorbidities.intel_def = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: true,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.intel_def
                      }, null, 8, ["question", "dataPresent", "hidePresent"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.asd'),
                        dataPresent: _ctx.comorbidities.asd,
                        onYesNoPresentEvent: _cache[3] || (_cache[3] = ($event: any) => (_ctx.comorbidities.asd = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: true,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.asd
                      }, null, 8, ["question", "dataPresent", "hidePresent"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_other_adhd_neurodes || this.comorbidities.history_other_adhd_neurodes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.motor_dis'),
                        dataPresent: _ctx.comorbidities.current_motor_dis,
                        onYesNoPresentEvent: _cache[4] || (_cache[4] = ($event: any) => (_ctx.comorbidities.current_motor_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_motor_dis,
                        onYesNoHistoryEvent: _cache[5] || (_cache[5] = ($event: any) => (_ctx.comorbidities.history_motor_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: _ctx.comorbidities.history_other_adhd_neurodes != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_motor_dis || _ctx.comorbidities.history_motor_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.comunic_dis'),
                        dataPresent: _ctx.comorbidities.current_comunic_dis,
                        onYesNoPresentEvent: _cache[6] || (_cache[6] = ($event: any) => (_ctx.comorbidities.current_comunic_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_comunic_dis,
                        onYesNoHistoryEvent: _cache[7] || (_cache[7] = ($event: any) => (_ctx.comorbidities.history_comunic_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: _ctx.comorbidities.history_other_adhd_neurodes != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_comunic_dis || _ctx.comorbidities.history_comunic_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.learn_dis'),
                        dataPresent: _ctx.comorbidities.current_learn_dis,
                        onYesNoPresentEvent: _cache[8] || (_cache[8] = ($event: any) => (_ctx.comorbidities.current_learn_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_learn_dis,
                        onYesNoHistoryEvent: _cache[9] || (_cache[9] = ($event: any) => (_ctx.comorbidities.history_learn_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: _ctx.comorbidities.history_other_adhd_neurodes != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_learn_dis || _ctx.comorbidities.history_learn_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.other_other_neurodes'),
                        dataPresent: _ctx.comorbidities.current_other_other_neurodes,
                        onYesNoPresentEvent: _cache[10] || (_cache[10] = ($event: any) => (_ctx.comorbidities.current_other_other_neurodes = $event)),
                        dataHistory: _ctx.comorbidities.history_other_other_neurodes,
                        onYesNoHistoryEvent: _cache[11] || (_cache[11] = ($event: any) => (_ctx.comorbidities.history_other_other_neurodes = $event)),
                        hidePresent: _ctx.comorbidities.current_other_adhd_neurodes != 1,
                        hideHistory: _ctx.comorbidities.history_other_adhd_neurodes != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_other_other_neurodes || _ctx.comorbidities.history_other_other_neurodes
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.psychotic_dis'),
              dataPresent: _ctx.comorbidities.current_psychotic_dis,
              onYesNoPresentEvent: _cache[12] || (_cache[12] = ($event: any) => (_ctx.comorbidities.current_psychotic_dis = $event)),
              dataHistory: _ctx.comorbidities.history_psychotic_dis,
              onYesNoHistoryEvent: _cache[13] || (_cache[13] = ($event: any) => (_ctx.comorbidities.history_psychotic_dis = $event)),
              key: _ctx.comorbidities.current_psychotic_dis || _ctx.comorbidities.history_psychotic_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_psychotic_dis || this.comorbidities.history_psychotic_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(), _createBlock(_component_currHistTextarea, {
                        dataCurrent: _ctx.comorbidities.current_psychotic_dis_text,
                        onCurrChanged: _cache[14] || (_cache[14] = ($event: any) => (_ctx.comorbidities.current_psychotic_dis_text = $event)),
                        dataHistory: _ctx.comorbidities.history_psychotic_dis_text,
                        onHistChanged: _cache[15] || (_cache[15] = ($event: any) => (_ctx.comorbidities.history_psychotic_dis_text = $event)),
                        hideCurrent: _ctx.comorbidities.current_psychotic_dis != 1,
                        hideHistory: _ctx.comorbidities.history_psychotic_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_psychotic_dis_text || _ctx.comorbidities.history_psychotic_dis_text
                      }, null, 8, ["dataCurrent", "dataHistory", "hideCurrent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.bipolar_dis'),
              dataPresent: _ctx.comorbidities.current_bipolar_dis,
              onYesNoPresentEvent: _cache[16] || (_cache[16] = ($event: any) => (_ctx.comorbidities.current_bipolar_dis = $event)),
              dataHistory: _ctx.comorbidities.history_bipolar_dis,
              onYesNoHistoryEvent: _cache[17] || (_cache[17] = ($event: any) => (_ctx.comorbidities.history_bipolar_dis = $event)),
              key: _ctx.comorbidities.current_bipolar_dis || _ctx.comorbidities.history_bipolar_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_bipolar_dis || this.comorbidities.history_bipolar_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(), _createBlock(_component_currHistTextarea, {
                        dataCurrent: _ctx.comorbidities.current_bipolar_dis_text,
                        onCurrChanged: _cache[18] || (_cache[18] = ($event: any) => (_ctx.comorbidities.current_bipolar_dis_text = $event)),
                        dataHistory: _ctx.comorbidities.history_bipolar_dis_text,
                        onHistChanged: _cache[19] || (_cache[19] = ($event: any) => (_ctx.comorbidities.history_bipolar_dis_text = $event)),
                        hideCurrent: _ctx.comorbidities.current_bipolar_dis != 1,
                        hideHistory: _ctx.comorbidities.history_bipolar_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_bipolar_dis_text || _ctx.comorbidities.history_bipolar_dis_text
                      }, null, 8, ["dataCurrent", "dataHistory", "hideCurrent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.depress_dis'),
              dataPresent: _ctx.comorbidities.current_depress_dis,
              onYesNoPresentEvent: _cache[20] || (_cache[20] = ($event: any) => (_ctx.comorbidities.current_depress_dis = $event)),
              dataHistory: _ctx.comorbidities.history_depress_dis,
              onYesNoHistoryEvent: _cache[21] || (_cache[21] = ($event: any) => (_ctx.comorbidities.history_depress_dis = $event)),
              key: _ctx.comorbidities.current_depress_dis || _ctx.comorbidities.history_depress_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_depress_dis || this.comorbidities.history_depress_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(), _createBlock(_component_currHistTextarea, {
                        dataCurrent: _ctx.comorbidities.current_depress_dis_text,
                        onCurrChanged: _cache[22] || (_cache[22] = ($event: any) => (_ctx.comorbidities.current_depress_dis_text = $event)),
                        dataHistory: _ctx.comorbidities.history_depress_dis_text,
                        onHistChanged: _cache[23] || (_cache[23] = ($event: any) => (_ctx.comorbidities.history_depress_dis_text = $event)),
                        hideCurrent: _ctx.comorbidities.current_depress_dis != 1,
                        hideHistory: _ctx.comorbidities.history_depress_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_depress_dis_text || _ctx.comorbidities.history_depress_dis_text
                      }, null, 8, ["dataCurrent", "dataHistory", "hideCurrent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.anxiety_dis'),
              dataPresent: _ctx.comorbidities.current_anxiety_dis,
              onYesNoPresentEvent: _cache[24] || (_cache[24] = ($event: any) => (_ctx.comorbidities.current_anxiety_dis = $event)),
              dataHistory: _ctx.comorbidities.history_anxiety_dis,
              onYesNoHistoryEvent: _cache[25] || (_cache[25] = ($event: any) => (_ctx.comorbidities.history_anxiety_dis = $event)),
              key: _ctx.comorbidities.current_anxiety_dis || _ctx.comorbidities.history_anxiety_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_anxiety_dis || this.comorbidities.history_anxiety_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.separat_anxiety_dis'),
                        dataPresent: _ctx.comorbidities.current_separat_anxiety_dis,
                        onYesNoPresentEvent: _cache[26] || (_cache[26] = ($event: any) => (_ctx.comorbidities.current_separat_anxiety_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_separat_anxiety_dis,
                        onYesNoHistoryEvent: _cache[27] || (_cache[27] = ($event: any) => (_ctx.comorbidities.history_separat_anxiety_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_anxiety_dis != 1,
                        hideHistory: _ctx.comorbidities.history_anxiety_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_separat_anxiety_dis || _ctx.comorbidities.history_separat_anxiety_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.fobia_dis'),
                        dataPresent: _ctx.comorbidities.current_fobia_dis,
                        onYesNoPresentEvent: _cache[28] || (_cache[28] = ($event: any) => (_ctx.comorbidities.current_fobia_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_fobia_dis,
                        onYesNoHistoryEvent: _cache[29] || (_cache[29] = ($event: any) => (_ctx.comorbidities.history_fobia_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_anxiety_dis != 1,
                        hideHistory: _ctx.comorbidities.history_anxiety_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_fobia_dis || _ctx.comorbidities.history_fobia_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.social_anxiety_dis'),
                        dataPresent: _ctx.comorbidities.current_social_anxiety_dis,
                        onYesNoPresentEvent: _cache[30] || (_cache[30] = ($event: any) => (_ctx.comorbidities.current_social_anxiety_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_social_anxiety_dis,
                        onYesNoHistoryEvent: _cache[31] || (_cache[31] = ($event: any) => (_ctx.comorbidities.history_social_anxiety_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_anxiety_dis != 1,
                        hideHistory: _ctx.comorbidities.history_anxiety_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_social_anxiety_dis || _ctx.comorbidities.history_social_anxiety_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.panic_dis'),
                        dataPresent: _ctx.comorbidities.current_panic_dis,
                        onYesNoPresentEvent: _cache[32] || (_cache[32] = ($event: any) => (_ctx.comorbidities.current_panic_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_panic_dis,
                        onYesNoHistoryEvent: _cache[33] || (_cache[33] = ($event: any) => (_ctx.comorbidities.history_panic_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_anxiety_dis != 1,
                        hideHistory: _ctx.comorbidities.history_anxiety_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_panic_dis || _ctx.comorbidities.history_panic_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.gad'),
                        dataPresent: _ctx.comorbidities.current_gad,
                        onYesNoPresentEvent: _cache[34] || (_cache[34] = ($event: any) => (_ctx.comorbidities.current_gad = $event)),
                        dataHistory: _ctx.comorbidities.history_gad,
                        onYesNoHistoryEvent: _cache[35] || (_cache[35] = ($event: any) => (_ctx.comorbidities.history_gad = $event)),
                        hidePresent: _ctx.comorbidities.current_anxiety_dis != 1,
                        hideHistory: _ctx.comorbidities.history_anxiety_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_gad || _ctx.comorbidities.history_gad
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.ocd'),
              dataPresent: _ctx.comorbidities.current_ocd,
              onYesNoPresentEvent: _cache[36] || (_cache[36] = ($event: any) => (_ctx.comorbidities.current_ocd = $event)),
              dataHistory: _ctx.comorbidities.history_ocd,
              onYesNoHistoryEvent: _cache[37] || (_cache[37] = ($event: any) => (_ctx.comorbidities.history_ocd = $event)),
              key: _ctx.comorbidities.current_ocd || _ctx.comorbidities.history_ocd
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.ptsd'),
              dataPresent: _ctx.comorbidities.current_ptsd,
              onYesNoPresentEvent: _cache[38] || (_cache[38] = ($event: any) => (_ctx.comorbidities.current_ptsd = $event)),
              dataHistory: _ctx.comorbidities.history_ptsd,
              onYesNoHistoryEvent: _cache[39] || (_cache[39] = ($event: any) => (_ctx.comorbidities.history_ptsd = $event)),
              key: _ctx.comorbidities.current_ptsd || _ctx.comorbidities.history_ptsd
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.eating_dis'),
              dataPresent: _ctx.comorbidities.current_eating_dis,
              onYesNoPresentEvent: _cache[40] || (_cache[40] = ($event: any) => (_ctx.comorbidities.current_eating_dis = $event)),
              dataHistory: _ctx.comorbidities.history_eating_dis,
              onYesNoHistoryEvent: _cache[41] || (_cache[41] = ($event: any) => (_ctx.comorbidities.history_eating_dis = $event)),
              key: _ctx.comorbidities.current_eating_dis || _ctx.comorbidities.history_eating_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_eating_dis || this.comorbidities.history_eating_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(), _createBlock(_component_currHistTextarea, {
                        dataCurrent: _ctx.comorbidities.current_eating_dis_text,
                        onCurrChanged: _cache[42] || (_cache[42] = ($event: any) => (_ctx.comorbidities.current_eating_dis_text = $event)),
                        dataHistory: _ctx.comorbidities.history_eating_dis_text,
                        onHistChanged: _cache[43] || (_cache[43] = ($event: any) => (_ctx.comorbidities.history_eating_dis_text = $event)),
                        hideCurrent: _ctx.comorbidities.current_eating_dis != 1,
                        hideHistory: _ctx.comorbidities.history_eating_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_eating_dis_text || _ctx.comorbidities.history_eating_dis_text
                      }, null, 8, ["dataCurrent", "dataHistory", "hideCurrent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.anorex'),
                        dataPresent: _ctx.comorbidities.current_anorex,
                        onYesNoPresentEvent: _cache[44] || (_cache[44] = ($event: any) => (_ctx.comorbidities.current_anorex = $event)),
                        dataHistory: _ctx.comorbidities.history_anorex,
                        onYesNoHistoryEvent: _cache[45] || (_cache[45] = ($event: any) => (_ctx.comorbidities.history_anorex = $event)),
                        hidePresent: _ctx.comorbidities.current_eating_dis != 1,
                        hideHistory: _ctx.comorbidities.history_eating_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_anorex || _ctx.comorbidities.history_anorex
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.bulimia'),
                        dataPresent: _ctx.comorbidities.current_bulimia,
                        onYesNoPresentEvent: _cache[46] || (_cache[46] = ($event: any) => (_ctx.comorbidities.current_bulimia = $event)),
                        dataHistory: _ctx.comorbidities.history_bulimia,
                        onYesNoHistoryEvent: _cache[47] || (_cache[47] = ($event: any) => (_ctx.comorbidities.history_bulimia = $event)),
                        hidePresent: _ctx.comorbidities.current_eating_dis != 1,
                        hideHistory: _ctx.comorbidities.history_eating_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_bulimia || _ctx.comorbidities.history_bulimia
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.binge'),
                        dataPresent: _ctx.comorbidities.current_binge,
                        onYesNoPresentEvent: _cache[48] || (_cache[48] = ($event: any) => (_ctx.comorbidities.current_binge = $event)),
                        dataHistory: _ctx.comorbidities.history_binge,
                        onYesNoHistoryEvent: _cache[49] || (_cache[49] = ($event: any) => (_ctx.comorbidities.history_binge = $event)),
                        hidePresent: _ctx.comorbidities.current_eating_dis != 1,
                        hideHistory: _ctx.comorbidities.history_eating_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_binge || _ctx.comorbidities.history_binge
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.other_eating_dis'),
                        dataPresent: _ctx.comorbidities.current_other_eating_dis,
                        onYesNoPresentEvent: _cache[50] || (_cache[50] = ($event: any) => (_ctx.comorbidities.current_other_eating_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_other_eating_dis,
                        onYesNoHistoryEvent: _cache[51] || (_cache[51] = ($event: any) => (_ctx.comorbidities.history_other_eating_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_eating_dis != 1,
                        hideHistory: _ctx.comorbidities.history_eating_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_other_eating_dis || _ctx.comorbidities.history_other_eating_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      _createVNode(_Transition, {
                        "enter-active-class": "animate__animated animate__fadeIn",
                        "leave-active-class": "animate__animated animate__fadeOut"
                      }, {
                        default: _withCtx(() => [
                          (this.comorbidities.current_other_eating_dis)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_openBlock(), _createBlock(_component_currHistTextarea, {
                                  dataCurrent: _ctx.comorbidities.current_other_eating_dis_text,
                                  onCurrChanged: _cache[52] || (_cache[52] = ($event: any) => (_ctx.comorbidities.current_other_eating_dis_text = $event)),
                                  hideCurrent: _ctx.comorbidities.current_other_eating_dis != 1,
                                  hideHistory: true,
                                  subQuestionLvl: 2,
                                  key: _ctx.comorbidities.current_other_eating_dis_text
                                }, null, 8, ["dataCurrent", "hideCurrent"]))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.conduct_dis'),
              dataPresent: _ctx.comorbidities.current_conduct_dis,
              onYesNoPresentEvent: _cache[53] || (_cache[53] = ($event: any) => (_ctx.comorbidities.current_conduct_dis = $event)),
              dataHistory: _ctx.comorbidities.history_conduct_dis,
              onYesNoHistoryEvent: _cache[54] || (_cache[54] = ($event: any) => (_ctx.comorbidities.history_conduct_dis = $event)),
              key: _ctx.comorbidities.current_conduct_dis || _ctx.comorbidities.history_conduct_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_conduct_dis || this.comorbidities.history_conduct_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.odd'),
                        dataPresent: _ctx.comorbidities.current_odd,
                        onYesNoPresentEvent: _cache[55] || (_cache[55] = ($event: any) => (_ctx.comorbidities.current_odd = $event)),
                        dataHistory: _ctx.comorbidities.history_odd,
                        onYesNoHistoryEvent: _cache[56] || (_cache[56] = ($event: any) => (_ctx.comorbidities.history_odd = $event)),
                        hidePresent: _ctx.comorbidities.current_conduct_dis != 1,
                        hideHistory: _ctx.comorbidities.history_conduct_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_odd || _ctx.comorbidities.history_odd
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.ied'),
                        dataPresent: _ctx.comorbidities.current_ied,
                        onYesNoPresentEvent: _cache[57] || (_cache[57] = ($event: any) => (_ctx.comorbidities.current_ied = $event)),
                        dataHistory: _ctx.comorbidities.history_ied,
                        onYesNoHistoryEvent: _cache[58] || (_cache[58] = ($event: any) => (_ctx.comorbidities.history_ied = $event)),
                        hidePresent: _ctx.comorbidities.current_conduct_dis != 1,
                        hideHistory: _ctx.comorbidities.history_conduct_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_ied || _ctx.comorbidities.history_ied
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.disrupt_impuls_conduct_dis'),
                        dataPresent: _ctx.comorbidities.current_disrupt_impuls_conduct_dis,
                        onYesNoPresentEvent: _cache[59] || (_cache[59] = ($event: any) => (_ctx.comorbidities.current_disrupt_impuls_conduct_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_disrupt_impuls_conduct_dis,
                        onYesNoHistoryEvent: _cache[60] || (_cache[60] = ($event: any) => (_ctx.comorbidities.history_disrupt_impuls_conduct_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_conduct_dis != 1,
                        hideHistory: _ctx.comorbidities.history_conduct_dis != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_disrupt_impuls_conduct_dis || _ctx.comorbidities.history_disrupt_impuls_conduct_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.tobac_dis'),
              dataPresent: _ctx.comorbidities.current_tobac_dis,
              onYesNoPresentEvent: _cache[61] || (_cache[61] = ($event: any) => (_ctx.comorbidities.current_tobac_dis = $event)),
              dataHistory: _ctx.comorbidities.history_tobac_dis,
              onYesNoHistoryEvent: _cache[62] || (_cache[62] = ($event: any) => (_ctx.comorbidities.history_tobac_dis = $event)),
              key: _ctx.comorbidities.current_tobac_dis || _ctx.comorbidities.history_tobac_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.addict'),
              dataPresent: _ctx.comorbidities.current_addict,
              onYesNoPresentEvent: _cache[63] || (_cache[63] = ($event: any) => (_ctx.comorbidities.current_addict = $event)),
              dataHistory: _ctx.comorbidities.history_addict,
              onYesNoHistoryEvent: _cache[64] || (_cache[64] = ($event: any) => (_ctx.comorbidities.history_addict = $event)),
              key: _ctx.comorbidities.current_addict || _ctx.comorbidities.history_addict
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.current_addict || this.comorbidities.history_addict)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.oh_dis'),
                        dataPresent: _ctx.comorbidities.current_oh_dis,
                        onYesNoPresentEvent: _cache[65] || (_cache[65] = ($event: any) => (_ctx.comorbidities.current_oh_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_oh_dis,
                        onYesNoHistoryEvent: _cache[66] || (_cache[66] = ($event: any) => (_ctx.comorbidities.history_oh_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_oh_dis || _ctx.comorbidities.history_oh_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.cann_dis'),
                        dataPresent: _ctx.comorbidities.current_cann_dis,
                        onYesNoPresentEvent: _cache[67] || (_cache[67] = ($event: any) => (_ctx.comorbidities.current_cann_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_cann_dis,
                        onYesNoHistoryEvent: _cache[68] || (_cache[68] = ($event: any) => (_ctx.comorbidities.history_cann_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_cann_dis || _ctx.comorbidities.history_cann_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.opi_dis'),
                        dataPresent: _ctx.comorbidities.current_opi_dis,
                        onYesNoPresentEvent: _cache[69] || (_cache[69] = ($event: any) => (_ctx.comorbidities.current_opi_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_opi_dis,
                        onYesNoHistoryEvent: _cache[70] || (_cache[70] = ($event: any) => (_ctx.comorbidities.history_opi_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_opi_dis || _ctx.comorbidities.history_opi_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.sed_dis'),
                        dataPresent: _ctx.comorbidities.current_sed_dis,
                        onYesNoPresentEvent: _cache[71] || (_cache[71] = ($event: any) => (_ctx.comorbidities.current_sed_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_sed_dis,
                        onYesNoHistoryEvent: _cache[72] || (_cache[72] = ($event: any) => (_ctx.comorbidities.history_sed_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_sed_dis || _ctx.comorbidities.history_sed_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.stimul_dis'),
                        dataPresent: _ctx.comorbidities.current_stimul_dis,
                        onYesNoPresentEvent: _cache[73] || (_cache[73] = ($event: any) => (_ctx.comorbidities.current_stimul_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_stimul_dis,
                        onYesNoHistoryEvent: _cache[74] || (_cache[74] = ($event: any) => (_ctx.comorbidities.history_stimul_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_stimul_dis || _ctx.comorbidities.history_stimul_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.other_subst_dis'),
                        dataPresent: _ctx.comorbidities.current_other_subst_dis,
                        onYesNoPresentEvent: _cache[75] || (_cache[75] = ($event: any) => (_ctx.comorbidities.current_other_subst_dis = $event)),
                        dataHistory: _ctx.comorbidities.history_other_subst_dis,
                        onYesNoHistoryEvent: _cache[76] || (_cache[76] = ($event: any) => (_ctx.comorbidities.history_other_subst_dis = $event)),
                        hidePresent: _ctx.comorbidities.current_addict != 1,
                        hideHistory: _ctx.comorbidities.history_addict != 1,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_other_subst_dis || _ctx.comorbidities.history_other_subst_dis
                      }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.personality_dis'),
              dataPresent: _ctx.comorbidities.personality_dis,
              onYesNoPresentEvent: _cache[77] || (_cache[77] = ($event: any) => (_ctx.comorbidities.personality_dis = $event)),
              hideHistory: true,
              key: _ctx.comorbidities.personality_dis
            }, null, 8, ["question", "dataPresent"])),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__fadeIn",
              "leave-active-class": "animate__animated animate__fadeOut"
            }, {
              default: _withCtx(() => [
                (this.comorbidities.personality_dis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.tap'),
                        dataPresent: _ctx.comorbidities.tap,
                        onYesNoPresentEvent: _cache[78] || (_cache[78] = ($event: any) => (_ctx.comorbidities.tap = $event)),
                        hidePresent: _ctx.comorbidities.personality_dis != 1,
                        hideHistory: true,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.tap
                      }, null, 8, ["question", "dataPresent", "hidePresent"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.bpd'),
                        dataPresent: _ctx.comorbidities.bpd,
                        onYesNoPresentEvent: _cache[79] || (_cache[79] = ($event: any) => (_ctx.comorbidities.bpd = $event)),
                        hidePresent: _ctx.comorbidities.personality_dis != 1,
                        hideHistory: true,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.bpd
                      }, null, 8, ["question", "dataPresent", "hidePresent"])),
                      (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                        question: _ctx.$t('Comorbidity.current_other_pysh_dis'),
                        dataPresent: _ctx.comorbidities.current_other_pysh_dis,
                        onYesNoPresentEvent: _cache[80] || (_cache[80] = ($event: any) => (_ctx.comorbidities.current_other_pysh_dis = $event)),
                        hidePresent: _ctx.comorbidities.personality_dis != 1,
                        hideHistory: true,
                        subQuestionLvl: 1,
                        key: _ctx.comorbidities.current_other_pysh_dis
                      }, null, 8, ["question", "dataPresent", "hidePresent"])),
                      _createVNode(_Transition, {
                        "enter-active-class": "animate__animated animate__fadeIn",
                        "leave-active-class": "animate__animated animate__fadeOut"
                      }, {
                        default: _withCtx(() => [
                          (this.comorbidities.current_other_pysh_dis)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (_openBlock(), _createBlock(_component_currHistTextarea, {
                                  dataCurrent: _ctx.comorbidities.current_other_pysh_dis_text,
                                  onCurrChanged: _cache[81] || (_cache[81] = ($event: any) => (_ctx.comorbidities.current_other_pysh_dis_text = $event)),
                                  hideCurrent: _ctx.comorbidities.current_other_pysh_dis != 1,
                                  hideHistory: true,
                                  subQuestionLvl: 2,
                                  key: _ctx.comorbidities.current_other_pysh_dis_text
                                }, null, 8, ["dataCurrent", "hideCurrent"]))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.history_other_pysh_dis'),
              dataHistory: _ctx.comorbidities.history_other_pysh_dis,
              onYesNoHistoryEvent: _cache[82] || (_cache[82] = ($event: any) => (_ctx.comorbidities.history_other_pysh_dis = $event)),
              hidePresent: true,
              key: _ctx.comorbidities.history_other_pysh_dis
            }, null, 8, ["question", "dataHistory"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.suicid_ideat'),
              dataPresent: _ctx.comorbidities.current_suicid_ideat,
              onYesNoPresentEvent: _cache[83] || (_cache[83] = ($event: any) => (_ctx.comorbidities.current_suicid_ideat = $event)),
              dataHistory: _ctx.comorbidities.history_suicid_ideat,
              onYesNoHistoryEvent: _cache[84] || (_cache[84] = ($event: any) => (_ctx.comorbidities.history_suicid_ideat = $event)),
              key: _ctx.comorbidities.current_suicid_ideat || _ctx.comorbidities.history_suicid_ideat
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.unstable_psyc_dis'),
              dataPresent: _ctx.comorbidities.current_unstable_psyc_dis,
              onYesNoPresentEvent: _cache[85] || (_cache[85] = ($event: any) => (_ctx.comorbidities.current_unstable_psyc_dis = $event)),
              hideHistory: true,
              key: _ctx.comorbidities.current_unstable_psyc_dis
            }, null, 8, ["question", "dataPresent"])),
            (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
              question: _ctx.$t('Comorbidity.medical_dis'),
              dataPresent: _ctx.contraindications.current_medical_dis,
              onYesNoPresentEvent: _cache[86] || (_cache[86] = ($event: any) => (_ctx.contraindications.current_medical_dis = $event)),
              dataHistory: _ctx.contraindications.history_medical_dis,
              onYesNoHistoryEvent: _cache[87] || (_cache[87] = ($event: any) => (_ctx.contraindications.history_medical_dis = $event)),
              key: _ctx.contraindications.current_medical_dis || _ctx.contraindications.history_medical_dis
            }, null, 8, ["question", "dataPresent", "dataHistory"])),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_Transition, {
                "enter-active-class": "animate__animated animate__fadeIn",
                "leave-active-class": "animate__animated animate__fadeOut"
              }, {
                default: _withCtx(() => [
                  (this.contraindications.current_medical_dis || this.contraindications.history_medical_dis)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                          question: _ctx.$t('Comorbidity.epilepsy'),
                          dataPresent: _ctx.contraindications.current_epilepsy,
                          onYesNoPresentEvent: _cache[88] || (_cache[88] = ($event: any) => (_ctx.contraindications.current_epilepsy = $event)),
                          dataHistory: _ctx.contraindications.history_epilepsy,
                          onYesNoHistoryEvent: _cache[89] || (_cache[89] = ($event: any) => (_ctx.contraindications.history_epilepsy = $event)),
                          hidePresent: !_ctx.contraindications.current_medical_dis,
                          hideHistory: !_ctx.contraindications.history_medical_dis,
                          subQuestionLvl: 1,
                          key: _ctx.contraindications.current_epilepsy || _ctx.contraindications.history_epilepsy
                        }, null, 8, ["question", "dataPresent", "dataHistory", "hidePresent", "hideHistory"])),
                        (_openBlock(), _createBlock(_component_yesNoCurrHistRadio, {
                          question: _ctx.$t('Comorbidity.unstable_medical_dis'),
                          dataPresent: _ctx.contraindications.current_unstable_medical_dis,
                          onYesNoPresentEvent: _cache[90] || (_cache[90] = ($event: any) => (_ctx.contraindications.current_unstable_medical_dis = $event)),
                          hideHistory: true,
                          subQuestionLvl: 1,
                          key: _ctx.contraindications.current_unstable_medical_dis
                        }, null, 8, ["question", "dataPresent"])),
                        _createVNode(_Transition, {
                          "enter-active-class": "animate__animated animate__fadeIn",
                          "leave-active-class": "animate__animated animate__fadeOut"
                        }, {
                          default: _withCtx(() => [
                            (this.contraindications.current_unstable_medical_dis)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_openBlock(), _createBlock(_component_currHistTextarea, {
                                    dataCurrent: _ctx.contraindications.current_unstable_medical_dis_text,
                                    onCurrChanged: _cache[91] || (_cache[91] = ($event: any) => (_ctx.contraindications.current_unstable_medical_dis_text = $event)),
                                    hideCurrent: _ctx.contraindications.current_unstable_medical_dis != 1,
                                    hideHistory: true,
                                    subQuestionLvl: 2,
                                    key: _ctx.contraindications.current_unstable_medical_dis_text
                                  }, null, 8, ["dataCurrent", "hideCurrent"]))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.$router.back())),
            type: "button",
            class: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          }, _toDisplayString(_ctx.$t('Comorbidity.Back')), 1),
          _createElementVNode("button", _hoisted_30, _toDisplayString(_ctx.$t('Comorbidity.Save')), 1)
        ])
      ])
    ], 32)
  ]))
}